/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { StoryblokMtaMasterclass } from '@mta/vela-api-types'
import { useAtomValue } from 'jotai'

import { PriceInfo } from '@/store/basket'
import { selectedCountryAtom } from '@/store/country'
import { getPricingZoneByCountryCode } from '@/utils/pricing-zones'

/**
 * Custom hook to calculate the price for an MTa Masterclass based on Storyblok data and the user's selected country.
 *
 * @param masterclass - the masterclass story
 */
const useMasterclassPrice = (masterclass: StoryblokMtaMasterclass): PriceInfo | null => {
  const selectedCountry = useAtomValue(selectedCountryAtom)

  // Determine the pricing zone based on the selected country
  const currentZone = selectedCountry ? getPricingZoneByCountryCode(selectedCountry.code) : null

  // Try to find matching zone pricing
  if (currentZone && masterclass.zone_pricing && masterclass.zone_pricing.length > 0) {
    const zonePrice = masterclass.zone_pricing.find((p) => p.zone === currentZone)
    if (zonePrice) {
      // Ensure amount is parsed correctly
      const amount = parseFloat(zonePrice.amount)
      if (!isNaN(amount)) {
        return {
          amount,
          currency: zonePrice.currency,
        }
      }
    }
  }

  // Ensure amount is parsed correctly
  const amount = parseFloat(masterclass.default_pricing.amount)
  if (!isNaN(amount)) {
    return {
      amount,
      currency: masterclass.default_pricing.currency,
    }
  }

  // No pricing information found
  return null
}

export { useMasterclassPrice }
